// ========================================
// Features Detail Page Scripts
// 機能詳細ページ専用のJavaScript（MainVisual-Tech スライダー）
// ========================================

/**
 * Swiperライブラリが読み込まれるまで待機する関数
 * @param {Function} callback - Swiper読み込み後に実行するコールバック関数
 * @param {number} maxAttempts - 最大試行回数（デフォルト: 50回 = 5秒）
 */
function waitForSwiperFeaturesDetail(callback, maxAttempts = 50) {
  let attempts = 0;
  const checkInterval = setInterval(() => {
    attempts++;

    if (typeof Swiper !== 'undefined') {
      clearInterval(checkInterval);
      callback();
    } else if (attempts >= maxAttempts) {
      clearInterval(checkInterval);
      console.error('[FeaturesDetail] Swiper library failed to load after', maxAttempts * 100, 'ms');
    }
  }, 100);
}

function initFeaturesDetailVisual() {
  const root = document.querySelector('.features-detail-carousel');
  if (!root) {
    return; // このページ以外では実行しない
  }

  const swiperElement = root.querySelector('.features-detail-carousel__swiper');
  const prevButton = root.querySelector('.features-detail-carousel__control-btn--prev');
  const nextButton = root.querySelector('.features-detail-carousel__control-btn--next');
  const thumbs = root.querySelectorAll('.features-detail-carousel__thumb');

  if (!swiperElement) {
    return;
  }

  const visualSwiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 0,
    // resizeObserver: false,
    // observer: false,
    a11y: {
      enabled: true,
    },
    on: {
      slideChange(swiper) {
        updateActiveThumb(swiper.activeIndex);
      },
    },
  });

  function updateActiveThumb(activeIndex) {
    thumbs.forEach((thumb, index) => {
      thumb.classList.toggle('is-active', index === activeIndex);
    });
  }

  // 初期状態のサムネイルをアクティブに
  updateActiveThumb(visualSwiper.activeIndex);

  // resizeObserverを無効化した代わりに、実際のウィンドウリサイズ時のみ
  // デバウンスしてSwiperのサイズを再計算する（連続リサイズループ対策）
  // let resizeTimer;
  // window.addEventListener('resize', () => {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(() => {
  //     visualSwiper.update();
  //   }, 200);
  // });

  // prev / next ボタン
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      visualSwiper.slidePrev();
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', () => {
      visualSwiper.slideNext();
    });
  }

  // サムネイルクリックでスライド切り替え
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      visualSwiper.slideTo(index);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  waitForSwiperFeaturesDetail(() => {
    initFeaturesDetailVisual();
  });
});
